import { render, staticRenderFns } from "./DropdownFilterProductGroup.vue?vue&type=template&id=ce47bbee&"
import script from "./DropdownFilterProductGroup.vue?vue&type=script&lang=js&"
export * from "./DropdownFilterProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce47bbee')) {
      api.createRecord('ce47bbee', component.options)
    } else {
      api.reload('ce47bbee', component.options)
    }
    module.hot.accept("./DropdownFilterProductGroup.vue?vue&type=template&id=ce47bbee&", function () {
      api.rerender('ce47bbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/DropdownFilterProductGroup.vue"
export default component.exports